<div>
    <mat-sidenav-container [hasBackdrop]="false" autosize style="height: calc(100vh - 50px); width:100%">
        <mat-sidenav #sidenav mode="side" opened style="display: block;">
            <mat-nav-list>
                <a mat-list-item style="height: 30px; font-size: 11pt;" (click) = "users()"><button  style="height: 30px;" mat-button class="navbar-items">Users</button></a>
                <a mat-list-item style="height: 30px; font-size: 11pt;" (click) = "groups()"><button style="height: 30px;" mat-button class="navbar-items">Groups</button></a>
            </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content style="margin-right: 0; padding:0">
            <div>
                <div class="card p-2 m-2" *ngIf="!isUsers && !isGroups">
                  <div class="card-body p-2">
                    Please select
                  </div>
                </div>
                <div class="card p-2 m-2" *ngIf="isUsers">
                    <app-users></app-users>
                </div>
                <div class="card p-2 m-2" *ngIf="isGroups">
                    <app-groups></app-groups>
                </div>
                
              </div>


        </mat-sidenav-content>
    </mat-sidenav-container>
</div>